<template>
  <div class="glossary-page">
    <div v-if="artEdit" class="glossary-page__header glossary-page__header--edit">
      <button class="glossary-page__back" type="button" @click="onHideArtEdit">
        <WorkbenchIcon name="chevron-left" :size="15" />
        <span>{{ $t('art_edit_excel') }}</span>
      </button>
      <span class="glossary-page__current">{{ artEditInfo && artEditInfo.termName }}</span>
    </div>

    <div v-else class="glossary-page__header">
      <div>
        <h1>{{ $t('art_title') }}</h1>
        <div class="glossary-page__description">
          <span>{{ $t('art_library_title_tip') }}</span>
          <el-tooltip effect="dark" placement="top" popper-class="enterprise-glossary-help-tooltip">
            <button class="glossary-page__help" type="button">
              <WorkbenchIcon name="circle-help" :size="14" />
            </button>
            <template #content>
              <div class="tooltipDiv">
                <div class="tooltip-title">{{ $t('art_library_title_tip1') }}</div>
                <div class="tooltip-title">{{ $t('art_library_title_tip2') }}</div>
                <div class="tooltip-title">{{ $t('art_library_title_tip3') }}</div>
                <div class="tooltip-title">{{ $t('art_library_title_tip4') }}</div>
                <div class="tooltip-title">
                  {{ $t('art_library_title_please_tip4') }}“<a
                    :href="appDomains.getHelpArticleUrl('termDatabase', isChina)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="folder-link"
                  >{{ $t('art_library_title_tip5') }}</a>”
                </div>
                <div class="tooltip-title">{{ $t('art_library_title_tip6') }}</div>
                <div class="tooltip-title">
                  {{ $t('art_library_title_please_tip4') }}“<a
                    :href="appDomains.getHelpArticleUrl('onlineEditing', isChina)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="folder-link"
                  >{{ $t('art_library_title_tip7') }}</a>”
                </div>
              </div>
            </template>
          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="glossary-page__content">
      <AccountArtLibraryList ref="accountArtLibraryList" @onUpPro="onMemberUp"
        @showEdit="(item)=>{artEditInfo = item; artEdit = true}" @hideEdit="()=>{artEdit = false}"
        @onContinueErrorCode="onContinueErrorCode" @enginePro="onProUp" />
    </div>
  </div>
</template>

<script setup lang="ts">
import AccountArtLibraryList from '@/components/Translate/Art/AccountArtLibraryList.vue'
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
import useBasicStore from '~/store/modules/basic'
import useUserStore from '~/store/modules/user'
const accountArtLibraryList = ref()
let artEditInfo = ref({})
let artEdit = ref(false)
const basicStore = useBasicStore()
const {isChina} = toRefs(basicStore)
const appDomains = useAppDomainConfig()
const route = useRoute()
const userStore = useUserStore()
const { userInfo } = storeToRefs(userStore)

// watch(route, (newVal, oldVal)=>{
//   if(oldVal.query.menu != newVal.query.menu){
//     if (userInfo.value && userInfo.value.bizTeamId) {
//       requestFileList()
//     }
//   }
// })

// 关闭编辑状态
function onHideArtEdit(){
  artEdit.value = false
  accountArtLibraryList.value && accountArtLibraryList.value.onHideEdit()
}

function onProUp() {
  
}
function onContinueErrorCode(errorCode, isContinue = false) {

}
// 去会员中心订阅 or 升级
function onMemberUp() {

}
</script>

<style lang="scss" scoped>
.glossary-page {
  display: flex;
  max-width: 100%;
  min-width: 0;
  flex-direction: column;
  gap: 18px;
}

.glossary-page__header {
  display: flex;
  min-height: 42px;
  align-items: flex-start;
  justify-content: space-between;

  h1 {
    margin: 0;
    color: #1f2329;
    font-size: 16px;
    font-weight: 800;
    line-height: 22px;
  }
}

.glossary-page__description {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 16px;
}

.glossary-page__help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #98a2b3;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.glossary-page__header--edit {
  min-height: 34px;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.glossary-page__back {
  display: inline-flex;
  height: 34px;
  align-items: center;
  gap: 5px;
  padding: 0 11px;
  color: #1f2329;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  background: #fff;
  border: 1px solid #e8ebf0;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    color: #2b7de9;
    border-color: #2b7de9;
  }
}

.glossary-page__current {
  max-width: 420px;
  overflow: hidden;
  color: #98a2b3;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;

  &::before {
    content: '/';
    margin-right: 10px;
    color: #d0d5dd;
  }
}

.glossary-page__content {
  min-width: 0;
}

.art-edit-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  max-width: 100%;
  .art-edit-title {
    color: var(--text-color);
    font-size: 16px;
    font-weight: bold;
    margin-left: 5px;
  }
  .libEditTitle {
    color: var(--text-color);
    font-size: 12px;
    line-height: 12px;
    margin-top: 3px;
    // line-height: 12px;
    margin-left: 10px;
  }
}

.libTitle {
  color: #8C8C8C;
  font-size: 12px;
  // line-height: 12px;
  margin-left: 10px;
}

.tooltipDiv {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 18px;
  flex-direction: column;
  display: flex;
  .tooltip-title {
    color: white;
    font-size: 12px;
    font-weight: bold;
  }
}

.folder-link {
  color: #2590E1;
  font-size: 12px;
  font-weight: bold;
  text-decoration: none; /* 去掉下划线 */
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.add-btn {
  padding: 8px 16px;
  background-color: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background-color: #40a9ff;
  }
}

.glossary-content {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 24px;
}

.search-bar {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.search-input, .language-filter {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
}

.search-input {
  flex: 1;
}

.glossary-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.glossary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  
  &:hover {
    background-color: #f8f9fa;
  }
}

.term-content {
  flex: 1;
}

.term-pair {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.term-source, .term-target {
  font-weight: 500;
  color: #333;
}

.term-arrow {
  color: #1890ff;
  font-weight: bold;
}

.term-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #666;
}

.term-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  padding: 4px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  font-size: 12px;
  
  &.edit {
    color: #1890ff;
    border-color: #1890ff;
    
    &:hover {
      background-color: #e6f7ff;
    }
  }
  
  &.delete {
    color: #ff4d4f;
    border-color: #ff4d4f;
    
    &:hover {
      background-color: #fff1f0;
    }
  }
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog-content {
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  min-width: 400px;
  
  h3 {
    margin: 0 0 20px 0;
    color: #333;
  }
}

.form-group {
  margin-bottom: 16px;
  
  label {
    display: block;
    margin-bottom: 8px;
    color: #333;
    font-weight: 500;
  }
  
  input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-size: 14px;
  }
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.btn-cancel, .btn-save {
  padding: 8px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-cancel {
  background-color: #fff;
  color: #666;
  
  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
}

.btn-save {
  background-color: #1890ff;
  color: #fff;
  border-color: #1890ff;
  
  &:hover {
    background-color: #40a9ff;
  }
}
</style>

<style lang="scss">
.enterprise-glossary-help-tooltip.el-popper {
  box-sizing: border-box;
  width: min(520px, calc(100vw - 32px));
  max-width: calc(100vw - 32px);
  white-space: normal;
  overflow-wrap: anywhere;
}
</style>
